export default class BD3DBuildInfo {
  static getVersion() {
    // Don't change this value!
    // It will be replaced with the current version after building
    return '1.10.0-142-g5cf22e7';
  }

  static get version() {
    return this.getVersion();
  }

  static getBuildDate() {
    // Don't change this value!
    // It will be replaced with the current build time after building
    return '2023/09/06 13:40:05';
  }

  static getBuildMode() {
    // Don't change this value!
    // It will be replaced with the current build mode after building
    return 'development';
  }
}
